import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("skg_cookies")) setShow(true);
  }, []);
  const accept = () => { localStorage.setItem("skg_cookies", "1"); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] glass border-t border-zinc-800 p-4 animate-fade-up" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center gap-4 justify-between">
        <p className="text-sm text-zinc-300 text-center sm:text-left">
          Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σου. Δες την{" "}
          <Link to="/legal/cookies" className="text-[#FF2E4C] underline">Πολιτική Cookies</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={accept} className="px-6 py-2.5 text-xs font-bold tracking-widest uppercase border border-zinc-700 rounded hover:bg-zinc-800" data-testid="cookie-decline">ΑΠΟΡΡΙΨΗ</button>
          <button onClick={accept} className="btn-red px-6 py-2.5 text-xs font-bold tracking-widest uppercase rounded" data-testid="cookie-accept">ΑΠΟΔΟΧΗ</button>
        </div>
      </div>
    </div>
  );
}
